/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Hero_H1_LeadInputs */

const es_landing_hero_h1_lead = /** @type {(inputs: Landing_Hero_H1_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que tu barco navegue más. Y se `)
};

const gl_landing_hero_h1_lead = /** @type {(inputs: Landing_Hero_H1_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que o teu barco navegue máis. E `)
};

const en_landing_hero_h1_lead = /** @type {(inputs: Landing_Hero_H1_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get your boat out more. And let it `)
};

/**
* | output |
* | --- |
* | "Get your boat out more. And let it" |
*
* @param {Landing_Hero_H1_LeadInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_hero_h1_lead = /** @type {((inputs?: Landing_Hero_H1_LeadInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Hero_H1_LeadInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_hero_h1_lead(inputs)
	if (locale === "en") return en_landing_hero_h1_lead(inputs)
	return es_landing_hero_h1_lead(inputs)
});